// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  maintenance: false,
  mfaRequiredForAllUsers: true,
  localApiServer: false,
  idleTimeoutSeconds: 1200,
  debugUserIdle: true,
  debugUserTiming: true,
  debugRouter: false,
  awsRegion: 'us-west-2',
  sentryDsn: 'https://fff8d1b7d8bc4209b21111a087f09301@sentry.io/1449790',
  captureApi: {
    url: 'https://t40b-r-qa.par8o.com/api/v1',
  },
  helpscoutApi: {
    token: '2ab8e508-c60b-4dc4-b370-e903091ced66',
  },
  pendo: {
    enabled: true,
    environment: 'QA'
  },
  featureData: {
    consultNotePages: true,
    usePdfKitViewer: true,
  },
  psPdfKit: {
    // cspell:disable-next
    licenseKey: 'p_YF9TQeXWtKXJDe1Q8mvMKBaipOXsyGgykOV1hlXWHiJu--5mTMIxxQOGX_DK2-NRcAOXFpsCeQgcGaRMD5advnRFgblKKBDavvRu4vUiXrfkRhxymm3v0PJ-d91ihcOtAl85cU3RPmN77Wlq9bNNa3EyfZ9DuAmXNRp5wApxWCevArQjmsHjSS3eiReY--B3fJaNuuGCF1nl4NSHzMXy7WfD0zYewdSbw2o0tdCslDoOqslHvLhOxtEu6dpYFzpV11iUBvl_ZZ5YUqS3MhFa69d338kTf18OFmqBTabvu0cWcXxT43m07ks38mpcg75bejhroXJElcCd6PEAfvZZ5YiDbZIB9M6ZRx2AZTSnrRkk_5cslAek-36eS6pgQKL-NWmp8x9jt1o2f-PX8NhYfQbTCgjaxjH_mGa9NdLHNN0jdaO0oU_h59AEOUvh5XbLt1CTcaTgtnyjmW4HoyMbFBMoIwbiv9sDIMSHELSNw-eORxJ9Hy4uKbvPLnLUOj11aywahepCDnGEtiKBlsipFP908HVOE2faUdi0MzC--6SIrW2XpbWNOmbwgPNWtw0Ak5n4H-tus9KhAHwKBri4iUcvyfUMPobyE1TihTMFqjK3hBCoXK9vWhei6qGy-1'
  },
};
